import Vue from 'vue'
import Router from 'vue-router'
import HomeTmpl from '../views/HomeTmpl.vue'
import Portfolio from '../views/myPortfolio/Portfolio.vue'
import routeGuards from './guards'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    component: HomeTmpl,
    children: [
      {
        path: '',
        component: Portfolio,
        name: 'Your Portfolio',
        meta: {
          title: 'Your Portfolio',
          requireAuth: true
        }
      }
    ]
  },
  { path: '*', redirect: '/' }]
})

router.beforeEach(routeGuards.authenticate)

export default router
